'use client';

import React from 'react';
import Link from 'next/link';

const EventTypes = () => {
    return (
        <section className="py-8 relative" aria-labelledby="event-types-heading">
            <div className="container mx-auto px-4 md:px-6 mb-1">
                <h2 id="event-types-heading" className="text-l text-white font-['Barlow']">CURATED BY EVENT</h2>
            </div>

            {/* Event boxes with video background - Full width container */}
            <div className="relative overflow-hidden w-full p-10">
                {/* Background Video - now only behind the boxes and full width */}
                <div className="absolute inset-0 w-full h-full z-0 bg-[#1C1C34]">
                    <video
                        className="w-full h-full object-cover"
                        autoPlay
                        muted
                        loop
                        playsInline
                        preload="auto"
                        poster="https://firebasestorage.googleapis.com/v0/b/rentabar-3d509.appspot.com/o/venues%2FKPUOnG8youRDUEw57iiK%2Fimages%2Fvideo-poster.jpg?alt=media&token=video-poster"
                        aria-hidden="true"
                    >
                        <source src="https://firebasestorage.googleapis.com/v0/b/rentabar-3d509.appspot.com/o/venues%2FKPUOnG8youRDUEw57iiK%2Fvideos%2F5a6a3baf.webm?alt=media&token=39b63288-f012-4441-bd65-75b6b6c3fb6b" type="video/webm" />
                        <source src="https://firebasestorage.googleapis.com/v0/b/rentabar-3d509.appspot.com/o/venues%2FKPUOnG8youRDUEw57iiK%2Fvideos%2F5a6a3baf.mp4?alt=media&token=39b63288-f012-4441-bd65-75b6b6c3fb6b" type="video/mp4" />
                    </video>
                </div>

                <div className="relative z-10 container mx-auto px-4 md:px-6 py-24">
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
                        {/* Event Type 1 */}
                        <Link
                            href="/search?attributes=birthday&date=2025-07-11&time=19%3A00&size=25"
                            className="group"
                            aria-label="Browse birthday party venues"
                        >
                            <div className="text-center bg-black bg-opacity-30 p-4 rounded-lg">
                                <span className="text-white text-lg md:text-xl font-bold font-['Barlow'] block">Birthday Party</span>
                            </div>
                        </Link>

                        {/* Event Type 2 */}
                        <Link
                            href="/search?attributes=rooftop&date=2025-07-11&time=19%3A00&size=25"
                            className="group"
                            aria-label="Browse rooftop bar venues"
                        >
                            <div className="text-center bg-black bg-opacity-30 p-4 rounded-lg">
                                <span className="text-white text-lg md:text-xl font-bold font-['Barlow'] block">Rooftop Bars</span>
                            </div>
                        </Link>

                        {/* Event Type 3 */}
                        <Link
                            href="/search?attributes=no+minimum+spend&date=2025-07-11&time=19%3A00&size=25"
                            className="group"
                            aria-label="Browse affordable party venues"
                        >
                            <div className="text-center bg-black bg-opacity-30 p-4 rounded-lg">
                                <span className="text-white text-lg md:text-xl font-bold font-['Barlow'] block">Affordable Party</span>
                                <span className="text-white text-sm font-['Barlow'] block">& no minimum spend</span>
                            </div>
                        </Link>

                        {/* Event Type 4 */}
                        <Link
                            href="/search?attributes=raw+space&date=2025-07-11&time=19%3A00&size=25"
                            className="group"
                            aria-label="Browse unique venues"
                        >
                            <div className="text-center bg-black bg-opacity-30 p-4 rounded-lg">
                                <span className="text-white text-lg md:text-xl font-bold font-['Barlow'] block">Unique Venues</span>
                            </div>
                        </Link>

                        {/* Event Type 5 */}
                        <Link
                            href="/search?attributes=wedding&date=2025-07-11&time=19%3A00&size=25"
                            className="group"
                            aria-label="Browse wedding venues"
                        >
                            <div className="text-center bg-black bg-opacity-30 p-4 rounded-lg">
                                <span className="text-white text-lg md:text-xl font-bold font-['Barlow'] block">Wedding Venues</span>
                                <span className="text-white text-sm font-['Barlow'] block">& Engagement Party</span>
                            </div>
                        </Link>

                        {/* Event Type 6 */}
                        <Link
                            href="/search?attributes=lounge&date=2025-07-11&time=19%3A00&size=25"
                            className="group"
                            aria-label="Browse lounge venues"
                        >
                            <div className="text-center bg-black bg-opacity-30 p-4 rounded-lg">
                                <span className="text-white text-lg md:text-xl font-bold font-['Barlow'] block">Lounges</span>
                                <span className="text-white text-sm font-['Barlow'] block">& Dance Clubs</span>
                            </div>
                        </Link>

                        {/* Event Type 7 */}
                        <Link
                            href="/search?attributes=raw+space&date=2025-07-11&time=19%3A00&size=25"
                            className="group"
                            aria-label="Browse event space rentals"
                        >
                            <div className="text-center bg-black bg-opacity-30 p-4 rounded-lg">
                                <span className="text-white text-lg md:text-xl font-bold font-['Barlow'] block">Event Space Rentals</span>
                            </div>
                        </Link>

                        {/* Event Type 8 */}
                        <Link
                            href="/search?attributes=baby+shower&date=2025-07-11&time=19%3A00&size=25"
                            className="group"
                            aria-label="Browse baby shower venues"
                        >
                            <div className="text-center bg-black bg-opacity-30 p-4 rounded-lg">
                                <span className="text-white text-lg md:text-xl font-bold font-['Barlow'] block">Baby Shower</span>
                            </div>
                        </Link>

                        {/* Event Type 9 */}
                        <Link
                            href="/search?attributes=corporate&date=2025-07-11&time=19%3A00&size=25"
                            className="group"
                            aria-label="Browse corporate event venues"
                        >
                            <div className="text-center bg-black bg-opacity-30 p-4 rounded-lg">
                                <span className="text-white text-lg md:text-xl font-bold font-['Barlow'] block">Corporate Events</span>
                            </div>
                        </Link>

                        {/* Event Type 10 */}
                        <Link
                            href="/search?attributes=great+cocktails&date=2025-07-11&time=19%3A00&size=25"
                            className="group"
                            aria-label="Browse cocktail bar venues"
                        >
                            <div className="text-center bg-black bg-opacity-30 p-4 rounded-lg">
                                <span className="text-white text-lg md:text-xl font-bold font-['Barlow'] block">Cocktail Bars</span>
                            </div>
                        </Link>

                        {/* Event Type 11 */}
                        <Link
                            href="/search?attributes=restaurant&date=2025-07-11&time=19%3A00&size=25"
                            className="group"
                            aria-label="Browse restaurant venues"
                        >
                            <div className="text-center bg-black bg-opacity-30 p-4 rounded-lg">
                                <span className="text-white text-lg md:text-xl font-bold font-['Barlow'] block">Restaurants</span>
                                <span className="text-white text-sm font-['Barlow'] block">with Private Rooms</span>
                            </div>
                        </Link>

                        {/* Event Type 12 */}
                        <Link
                            href="/search?attributes=holiday+party&date=2025-07-11&time=19%3A00&size=25"
                            className="group"
                            aria-label="Browse holiday party venues"
                        >
                            <div className="text-center bg-black bg-opacity-30 p-4 rounded-lg">
                                <span className="text-white text-lg md:text-xl font-bold font-['Barlow'] block">Holiday Party</span>
                                <span className="text-white text-sm font-['Barlow'] block">Venues</span>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>


            {/* New intro section with title and text */}
            <div className="container mx-auto px-4 md:px-6 text-center mb-0 mt-6">
                <h1 className="text-3xl md:text-4xl font-semibold text-white mb-4 font-['Inter']">Find Top-Rated Event Spaces in NYC for Every Occasion</h1>
                <p className="text-white text-lg max-w-3xl mx-auto mb-6 font-['Inter']">
                    From private party rooms and affordable party venues to elegant wedding venues in NYC. Browse hundreds of curated options.
                </p>
                <Link
                    href="/search?date=2025-07-11&time=19%3A00&size=25"
                    className="bg-[#C0C0DD] hover:bg-[#AAAAC8] text-black px-8 py-3 rounded-full text-lg font-medium inline-block font-['Barlow'] whitespace-nowrap"
                    aria-label="Browse all NYC event venues"
                >
                    BROWSE All NYC EVENT VENUES
                </Link>
            </div>

        </section>
    );
};

export default EventTypes;